var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrows1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26.3",
    style: {
      enableBackground: "new 0 0 26 26.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#253449;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.3,19.4l-2.7,3c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.5-0.1-0.7-0.3l-2.7-3c-0.1-0.2-0.2-0.4-0.2-0.6 c0-0.5,0.4-0.9,0.9-0.9c0.3,0,0.5,0.1,0.7,0.3l1.1,1.3v-15c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v15l1.1-1.3 c0.2-0.2,0.4-0.3,0.7-0.3c0.5,0,0.9,0.4,0.9,0.9C20.5,19.1,20.4,19.3,20.3,19.4z M11.8,8.4c-0.3,0-0.5-0.1-0.7-0.3L10,6.8v15 c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9v-15L7.1,8.1C6.9,8.2,6.7,8.4,6.4,8.4C5.9,8.4,5.5,8,5.5,7.5c0-0.2,0.1-0.4,0.2-0.6l2.7-3 c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3l2.7,3c0.1,0.2,0.2,0.4,0.2,0.6C12.7,8,12.3,8.4,11.8,8.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows1);
export default __webpack_public_path__ + "static/media/arrows1.8a9e8b59.svg";
export { ForwardRef as ReactComponent };